import { RootState } from '../../../applicationStore';
import { ActivitiesState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getActivitiesState = (state: RootState): ActivitiesState =>
  state.activities;

export const getActivitiesLoader = createSelector(
  getActivitiesState,
  (state): boolean => state.loading,
);

export const getActivitiesData = createSelector(
  getActivitiesState,
  (state): ActivitiesState['data'] | null => state?.data || [],
);
